"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.userGroup.list': 'User Groups',
    'route.userGroup.create': 'Add User Group',
    'route.userGroup.edit': 'Edit User Group',
};
